// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"85035627","42":"aada80a8","57":"751e1aeb","116":"b86d6a0f","205":"736c4443","400":"b6c14213","638":"17982957","925":"2191294e"}[chunkId] + ".chunk.js";
};